import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
const ILLUMINATE_SCOPE = "ILLUMINATE";
const useSendIlluminateReportDownloadedTelemetry = (appSection) => {
  const sendTelemetry = useSendTelemetry(appSection);
  return (report) => {
    var _a;
    if (((_a = report._scope) == null ? void 0 : _a.toUpperCase()) !== ILLUMINATE_SCOPE) {
      return;
    }
    sendTelemetry(TELEMETRY_EVENT_TYPE.REPORT.ILLUMINATE_DOWNLOAD, {
      app_pathname: "report",
      event_details: { report_title: report.title }
    });
  };
};
export default useSendIlluminateReportDownloadedTelemetry;
